// components/OperationalBenefits.tsx
"use client";

import * as React from "react";
import {
    Box,
    Grid,
    Stack,
    Typography,
    IconButton,
    Button,
    useTheme,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Heading from "../heading";
import RingBenefitsExact from "./RingBenefitsExact";
import Compliance from "./Compliance";
import CtaButton from "../buttonWithArrow";


/** ——————————— Helpers ——————————— */
const polarToCartesian = (cx, cy, r, deg) => {
    const rad = (deg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy - r * Math.sin(rad) };
};

const defaultProps = {
    eyebrow: "Choose which suits you better",
    title: "Operational Benefits",
    ringBullets: [
        { text: "Flexible participation:\nown or co-invest", angle: 140 },
        { text: "Transparent revenue reporting", angle: 220 },
        { text: "Fully managed by RSL", angle: 40 },
        { text: "Listed on UAE & global\nplatforms for maximum revenue", angle: 320 },
    ],
    centerCaption: "Access to premium UAE rental\nmarket with global exposure",
    complianceTitle: "Compliance & Car Standards",
    complianceItems: [
        {
            title: "Regulations & Maintenance",
            description:
                "All vehicles must comply with UAE traffic regulations and undergo regular maintenance.",
        },
        {
            title: "Insurance & Tracking",
            description:
                "RSL Rental ensures insurance coverage, RMS tracking systems, and registration compliance.",
        },
        {
            title: "Inspection Process",
            description:
                "Vehicles are inspected prior to onboarding and periodically throughout the investment period.",
        },
    ],
    ctaLabel: "Invest Now",
    onCtaClick: () => { },
};

/** ——————————— Component ——————————— */
export default function OperationalBenefits({ data, onClick }) {
    const { title, subtitle, ringImage, complianceImage, button } = data;

    return (
        <>
            <Box
                component="section"
                className="container" // ← Bootstrap container (optional)
                sx={{
                    pt: { xs: 6, md: 10 },
                }}
            >
                {/* Header */}
                <Heading title={title} subtitle={subtitle} />

                <RingBenefitsExact src={ringImage?.src} alt={ringImage?.alt} />
            </Box>
            <Box sx={{ mb: { xs: 2, md: 6 } }}>
                <Compliance src={complianceImage?.src} alt={complianceImage?.alt} ratio="842 / 390"
                    rounded />
            </Box>
            {/* CTA */}
            {
                button && <Stack alignItems="center" sx={{ mt: { xs: 2, md: 2 }, mb: { xs: 2, md: 6 } }}>
                    <CtaButton label={button?.text} onClick={() => onClick()} />
                    {/* <CtaButton cta={{ label: button?.text, href: button?.link }} /> */}
                </Stack>
            }

        </>
    );
}
